import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import {
  ReportBuilderDataSource,
  ReportBuilderDataSourceInstance,
} from '@principle-theorem/reporting';
import { QueryFilterDisplayComponent } from '../query-filter-display/query-filter-display.component';

@Component({
  selector: 'pr-queryable-timestamp-display',
  templateUrl: './queryable-timestamp-display.component.html',
  styleUrls: ['./queryable-timestamp-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgCommonModule, QueryFilterDisplayComponent],
  host: {
    class: 'inline-block',
  },
})
export class QueryableTimestampDisplayComponent {
  timestampLabel: Signal<string | undefined>;

  dataSource = input.required<ReportBuilderDataSourceInstance | undefined>();
  queryableTimestamp = input.required<string | undefined>();

  constructor() {
    // this.dataSource = computed(() =>
    //   resolveDataSource(
    //     this.customReport().dataSource,
    //     REPORT_BUILDER_DATA_SOURCES
    //   )
    // );
    this.timestampLabel = computed(() =>
      ReportBuilderDataSource.resolvePropertyLabel(
        this.dataSource(),
        this.queryableTimestamp()
      )
    );
  }
}
